export enum DownloadedDocumentAccessType {
    DownloadOneDocument = "DownloadOneDocument",
    DownloadAllDocuments = "DownloadAllDocuments",
    DownloadIntexFile = "DownloadIntexFile",
    DownloadManagerPresentationFile = "DownloadManagerPresentationFile",
    DownloadDisclosureFile = "DownloadDisclosureFile",
    ExportTargetPortfolio = "ExportTargetPortfolio",
};
